export default __webpack_public_path__ + "static/media/man.84beba42.svg";